import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import theme from '../../theme/Theme';
import befly from '../../../assets/images/befly.png';


import styled from "styled-components";

const DivLogin = styled.div`
    background-color:#041E42;
    position:fixed;
    z-index:0;
    width:100%;
    height:100%;
    background-attachment: fixed;
    background-size: cover;
    background-position: right top;
`
const Titulo = styled(Typography)`
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    position:relative;
    z-index:2; 
    color:white;
    font-family: "Lucida Sans" !important;
    padding-top:20vh; 
    color:white;
`

const DivLogo = styled.div`
    align-items: center;
    z-index: -1;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    position:relative;
    font-family: "Lucida Sans" !important;
`

const ImagemLogo = styled.img`
    width:450px;
    height:220px;
`

export default function PageNotFound() {
    return (
        <>
            <ThemeProvider theme={theme}>
                <DivLogin>
                    <DivLogo>
                        <ImagemLogo src={befly} />
                    </DivLogo>
                <Titulo variant="h3" gutterBottom>
                    PÁGINA NÃO ENCONTRADA
                </Titulo>
                </DivLogin>
            </ThemeProvider>
        </>
    );
}